<template>
    <option value="one-time">One-time Run</option>
    <option value="monthly">Monthly</option>
    <option value="weekly">Weekly</option>
    <option value="daily">Daily</option>
    <option value="hourly">Hourly</option>
</template>
